<template>
    <div class="max-w-screen-xl mx-auto mt-12 md:mt-18 lg:mt-20 xl:mt-24 md:mb-8 mb-6 px-4">

        <h2 class="text-2xl sm:text-3xl font-semibold mb-10" v-html="dataLocales.any_content.title">

        </h2>
        <div class="grid grid-cols-12 lg:gap-8">
            <div class="lg:col-span-7 col-span-12">
                <div class="mb-6" v-for="post in dataLocales.data">
                    <h3 class="text-xl sm:text-2xl font-semibold mb-3"> {{ post.title }}</h3>
                    <div class="text-base lg:text-lg" v-html="post.description">

                    </div>
                </div>

            </div>
            <div class="lg:col-span-5 lg:block hidden">
                <nuxt-img loading="lazy" src="/card.png" height="420px" alt="vcard-qrcode" format="webp" />
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import MultiDataLocale from '~~/config/interface/MultiDataLocale';


const dataLocales = new MultiDataLocale([
    {
        locale: "en",
        title: "<span class='text-success'> QR Code</span> can replace paper business cards",
        data: [
            {
                title: "Create an unlimited number of business card QR codes for free",
                description: "<p>Scan the code to view the name, position, phone number, map navigation, and personal introduction.</p>"
            },
            {
                title: "Support one-click saving to contacts",
                description: "<p>Manage your business card in social network, including viewing, editing, and forwarding.</p> <p>Real-time statistics on the number of views and saves of your business card, to better understand its distribution effectiveness.</p>"
            }
        ]
    },
    {
        locale: "vi",
        title: "<span class='text-success'> Mã QR</span> có thể thay thế cho danh thiếp giấy",
        data: [
            {
                title: "Tạo mã QR danh thiếp không giới hạn miễn phí",
                description: "<p>Quét mã QR để xem tên, chức vụ, số điện thoại, định vị bản đồ và giới thiệu cá nhân.</p>"
            },
            {
                title: "Hỗ trợ lưu vào danh bạ chỉ với một cú nhấp chuột",
                description: "<p>Quản lý danh thiếp của bạn trên mạng xã hội, bao gồm xem, chỉnh sửa và chuyển tiếp.</p> <p>Thống kê thời gian thực về số lượt xem và lưu trữ của danh thiếp của bạn, để hiểu rõ hơn về hiệu quả phân phối của nó.</p>"
            }
        ]
    },
    {
        locale: "de",
        title: "<span class='text-success'> QR-Code</span> kann Visitenkarten ersetzen",
        data: [
            {
                title: "Erstellen Sie eine unbegrenzte Anzahl von Visitenkarten-QR-Codes kostenlos",
                description: "<p>Scannen Sie den Code, um den Namen, die Position, die Telefonnummer, die Kartenavigation und die persönliche Vorstellung zu sehen.</p>"
            },
            {
                title: "Unterstützung für Ein-Klick-Speichern in Kontakten",
                description: "<p>Verwalten Sie Ihre Visitenkarte in sozialen Netzwerken, einschließlich Anzeigen, Bearbeiten und Weiterleiten.</p> <p>Echtzeitstatistiken über die Anzahl der Ansichten und Speicherungen Ihrer Visitenkarte, um ihre Verteilungseffektivität besser zu verstehen.</p>"
            }
        ]
    },
    {
        locale: "it",
        title: "<span class='text-success'> QR Code</span> può sostituire le tradizionali schede da visita cartacee",
        data: [
            {
                title: "Crea un numero illimitato di codici QR per le tue schede da visita gratuitamente",
                description: "<p>Scansiona il codice per visualizzare il nome, la posizione, il numero di telefono, la navigazione sulla mappa e la presentazione personale.</p>"
            },
            {
                title: "Supporto al salvataggio con un solo clic nella rubrica",
                description: "<p>Gestisci la tua scheda da visita sui social network, inclusi la visualizzazione, la modifica e l'inoltro.</p> <p>Statistiche in tempo reale sul numero di visualizzazioni e salvataggi della tua scheda da visita, per capire meglio l'efficacia della distribuzione.</p>"
            }
        ]
    },
    {
        locale: "fr",
        title: "Le <span class='text-success'>QR Code</span> peut remplacer les cartes de visite papier",
        data: [
            {
                title: "Créez un nombre illimité de codes QR de cartes de visite gratuitement",
                description: "<p>Scannez le code pour afficher le nom, le poste, le numéro de téléphone, la navigation sur la carte et une présentation personnelle.</p>"
            },
            {
                title: "Prise en charge de l'enregistrement en un clic dans les contacts",
                description: "<p>Gérez votre carte de visite dans les réseaux sociaux, y compris la consultation, l'édition et la transmission.</p> <p>Statistiques en temps réel sur le nombre de vues et d'enregistrements de votre carte de visite, pour mieux comprendre son efficacité de distribution.</p>"
            }
        ]
    },
    {
        locale: "es",
        title: "El <span class='text-success'>código QR</span> puede reemplazar las tarjetas de visita en papel",
        data: [
            {
                title: "Cree un número ilimitado de códigos QR de tarjetas de visita de forma gratuita",
                description: "<p>Escanee el código para ver el nombre, el cargo, el número de teléfono, la navegación en el mapa y una presentación personal.</p>"
            },
            {
                title: "Admite el guardado en contactos con un solo clic",
                description: "<p>Gestione su tarjeta de visita en redes sociales, incluyendo la visualización, edición y transmisión.</p> <p>Estadísticas en tiempo real sobre el número de vistas y guardados de su tarjeta de visita, para comprender mejor su eficacia de distribución.</p>"
            }
        ]
    },
    {
        locale: "pt",
        title: "O <span class='text-success'>código QR</span> pode substituir os cartões de visita em papel",
        data: [
            {
                title: "Crie um número ilimitado de códigos QR de cartões de visita gratuitamente",
                description: "<p>Escanee o código para visualizar o nome, cargo, número de telefone, navegação no mapa e uma apresentação pessoal.</p>"
            },
            {
                title: "Suporte para salvar em contatos com um único clique",
                description: "<p>Gerencie seu cartão de visita em redes sociais, incluindo visualização, edição e transmissão.</p> <p>Estatísticas em tempo real sobre o número de visualizações e salvamentos do seu cartão de visita, para melhor compreender sua eficácia de distribuição.</p>"
            }
        ]
    },
    {
        locale: "nl",
        title: "<span class='text-success'>QR-code</span> kan papieren visitekaartjes vervangen",
        data: [
            {
                title: "Maak een onbeperkt aantal visitekaartje QR-codes gratis aan",
                description: "<p>Scan de code om de naam, functie, telefoonnummer, kaartnavigatie en persoonlijke introductie te bekijken.</p>"
            },
            {
                title: "Ondersteunt opslaan met één klik naar contacten",
                description: "<p>Beheer uw visitekaartje op sociale netwerken, inclusief bekijken, bewerken en doorsturen.</p> <p>Ondersteunt real-time statistieken over het aantal weergaven en opslagen van uw visitekaartje, om beter inzicht te krijgen in de effectiviteit van de distributie.</p>"
            }
        ]
    },
    {
        locale: "ja",
        title: "<span class='text-success'>QRコード</span>で紙の名刺を置き換えることができます",
        data: [
            {
                title: "無制限の無料ビジネスカードQRコードを作成できます",
                description: "<p>コードをスキャンして、名前、役職、電話番号、地図ナビゲーション、自己紹介を表示できます。</p>"
            },
            {
                title: "ワンクリックでコンタクトに保存できます",
                description: "<p>ソーシャルネットワークでビジネスカードを管理できます。表示、編集、転送を含みます。</p> <p>ビジネスカードの閲覧数と保存数のリアルタイム統計をサポートし、その配布効果をより正確に把握できます。</p>"
            }
        ]
    },
    {
        locale: "zh",
        title: "<span class='text-success'>QR码</span>可以取代纸质名片",
        data: [
            {
                title: "免费创建无限数量的名片QR码",
                description: "<p>扫描二维码即可查看姓名、职位、电话号码、地图导航和个人介绍。</p>"
            },
            {
                title: "支持一键保存至通讯录",
                description: "<p>在社交网络中管理您的名片，包括查看、编辑和转发。</p> <p>实时统计名片的浏览次数和保存次数，更好地了解其分发效果。</p>"
            }
        ]
    }
])

</script>